<template>
    <b-form-group class="dark-text m-0">
        <div class="card m-0 pl-3 p-2">
            <div>
                <h5 class="title">{{ title }}</h5>
                <h6 class="mr-auto">{{ question }}</h6>
                <Scale
                    :model="$v.form.score.$model"
                    :disabled="disabled"
                    @change="onChange"
                />
            </div>
            <b-collapse id="collapse-comments" v-model="isCollapseOpen">
                <b-media vertical-align="center">
                    <b-row no-gutters>
                        <b-col sm="9" md="9" lg="10" xl="10" class="pr-0">
                            <div
                                v-if="isEnableComments"
                                class="p-0 mt-2"
                                style="font-weight: 500"
                            >
                                <label>{{
                                    $t('profile.pendencies.commentsLabel') +
                                    (requireComment ? '*' : '')
                                }}</label>
                                <b-form-textarea
                                    v-model="$v.form.comment.$model"
                                    :state="checkState('comment')"
                                    :disabled="disabled"
                                ></b-form-textarea>
                                <span v-if="!$v.form.comment.maxLength">
                                    {{
                                        $t('form.validations.maxLength', {
                                            value: '500',
                                        })
                                    }}
                                </span>
                            </div>
                            <div class="p-0 mt-2 text-muted">
                                <b-form-checkbox
                                    id="btn-enps-research-answer-anonymously"
                                    v-model="$v.form.isAnonymous.$model"
                                    :disabled="disabled"
                                    size="sm"
                                    >{{
                                        $t(
                                            'profile.pendencies.answerAnonymously'
                                        )
                                    }}
                                </b-form-checkbox>
                            </div>
                        </b-col>
                        <b-col
                            sm="3"
                            md="3"
                            lg="2"
                            xl="2"
                            class="align-self-center p-0 ml-0"
                        >
                            <div class="text-right">
                                <b-button
                                    id="btn-enps-research-cancel"
                                    class="button text-muted"
                                    size="sm"
                                    variant="outline"
                                    active-class="active"
                                    :disabled="disabled"
                                    @click="cancel"
                                    >{{ $t('form.button.cancel') }}</b-button
                                >
                                <b-button
                                    id="btn-enps-research-submit"
                                    class="button"
                                    size="sm"
                                    variant="primary"
                                    :disabled="disabled || $v.form.$invalid"
                                    @click="onSubmit"
                                    >{{ $t('form.button.send') }}
                                </b-button>
                            </div>
                        </b-col>
                    </b-row>
                </b-media>
            </b-collapse>
        </div>
    </b-form-group>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { Scale } from './components'
import { CTextArea } from '@/views/components/fields'
import { required, requiredIf, maxLength } from 'vuelidate/lib/validators'

export default {
    components: {
        Scale,
        CTextArea,
    },
    mixins: [validationMixin],
    props: {
        researchId: String | Number,
        title: {
            type: String,
            required: true,
        },
        question: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        isEnableComments: {
            type: Boolean,
            default: true,
        },
        requireComment: {
            type: Boolean,
            default: false,
        },
        submit: {
            type: Function,
            required: true,
        },
    },
    validations: {
        form: {
            score: {
                required,
            },
            comment: {
                required: requiredIf(function () {
                    return this.requireComment
                }),
                maxLength: maxLength(500),
            },
            isAnonymous: {
                required,
            },
        },
    },
    data() {
        return {
            form: {
                score: null,
                comment: null,
                isAnonymous: false,
            },
            isCollapseOpen: false,
        }
    },
    methods: {
        onSubmit() {
            let data = this.getData()
            this.submit(data)
        },
        getData() {
            return {
                enps_research_id: this.researchId,
                score: this.$v.form.score.$model,
                comment: this.$v.form.comment.$model,
                is_anonymous: this.$v.form.isAnonymous.$model,
            }
        },
        onChange(degreeId) {
            this.isCollapseOpen = true
            this.form.score = degreeId
        },
        emitSubmitEvent(value) {
            this.$emit('submit', value)
        },
        cancel() {
            this.isCollapseOpen = false
            this.form.score = null
            this.form.comment = null
            this.form.isAnonymous = false
            this.$v.$reset()
        },
        checkState(val) {
            const field = this.$v.form[val]
            return field.$dirty ? !field.$invalid : null
        },
    },
}
</script>
<style lang="scss" scoped>
.title {
    font-weight: bold;
    margin-bottom: 0.5rem;
}
.dark-text {
    color: #3b3f4e;
}
.active {
    background-color: white;
}
.button {
    width: 50%;
    border-radius: 5px;
    font-weight: bold;
}
</style>
